import React from 'react';

interface Props {
	children: JSX.Element | JSX.Element[];
}

const GroupFragment = (props: Props) => (
	<React.Fragment>{props.children}</React.Fragment>
);
GroupFragment.isGroupedFormField = true;
export default GroupFragment;
